import { Search } from 'lucide-react'

export interface SearchBoxProps {
  value: string
  onChange: (v: string) => void
  placeholder: string
  counter?: string
}

export function SearchBox({ value, onChange, placeholder, counter }: SearchBoxProps) {
  return (
    <div className="relative">
      <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-[#94A3B8]" />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="h-9 w-full rounded-[10px] border border-[rgba(15,23,42,0.07)] bg-white pl-9 pr-16 text-[13px] text-[#0F172A] placeholder:text-[#94A3B8] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#2563EB]"
      />
      {counter ? (
        <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 font-mono text-[11px] tabular-nums text-[#94A3B8]">
          {counter}
        </span>
      ) : null}
    </div>
  )
}
